import React from 'react'
import clsx from 'clsx'
import {Typography} from '../components/Typography'
import {Button} from '../components/Button'
import {ChamadaAzul} from '../components/ChamadaAzul'
import {ImgFilters} from '../components/ImgFilters'
import {Depositions} from '../components/Depoimentos'
import {useProfessorsQuery} from '../utils/hooks/useProfessorsQuery'
import coursesImage from '../img/courses-01.jpg'
import iconParaQuem from '../img/icons/feo-para-quem.svg'
import iconAgenda from '../img/icons/feo-agenda.svg'
import iconBeneficios from '../img/icons/feo-beneficios.svg'

const Tag = ({children, className}) => {
  const styles = clsx(
    `text-base inline-block bg-purple-500 text-white rounded-full px-5 py-1 uppercase font-bold font-muli`,
    className,
  )

  return <div className={styles}>{children}</div>
}

const Hero = () => {
  return (
    <div className="relative w-full h-40">
      <ImgFilters img={coursesImage} variant="blue" transparency />
    </div>
  )
}

const TitleSection = ({title, subtitle}) => {
  return (
    <div className="flex flex-col justify-center p-4 lg:pr-100">
      <Typography as="div">
        <Typography as="span" uppercase color="blue-500">
          Cursos
        </Typography>{' '}
        /{' '}
        <Typography as="span" uppercase color="blue-500">
          Cursos de extensão
        </Typography>{' '}
        /{' '}
        <Typography as="span" uppercase color="gray-900">
          {title}
        </Typography>
      </Typography>

      <Typography variant="heading" color="blue-500" className="my-2">
        {title}
      </Typography>

      <Typography variant="heading" color="gray-500" weight="normal">
        {subtitle}
      </Typography>
    </div>
  )
}

const IntroSection = ({title = 'CONHEÇA O CURSO', introduction, videoLink}) => {
  const {videoId} =
    videoLink.match(/https:\/\/vimeo.com\/(?<videoId>[0-9]+)\/.+/)?.groups ?? {}

  const videoLinkPlayer = `https://player.vimeo.com/video/${videoId}`
  return (
    <div className="flex flex-col justify-center px-4 py-8 bg-gray-500-to-900-y space-y-6 lg:pr-100">
      <Typography
        color="white"
        size="lg"
        uppercase
        weight="bold"
        align="center"
        className="lg:text-left"
      >
        {title}
      </Typography>
      <div className="lg:h-96">
        <iframe
          title="video player"
          src={videoLinkPlayer}
          width="100%"
          height="100%"
          frameBorder="0"
          allowFullScreen
          allow="autoplay; fullscreen"
        ></iframe>
      </div>
    </div>
  )
}

const CourseDetails = ({
  investment,
  professor = [],
  forWho,
  cargaHoraria,
  beneficios = [],
  image,
  ref,
  setHeight,
}) => {
  professor = professor || []
  beneficios = beneficios || []
  const detailRef = React.useRef()
  React.useEffect(() => {
    setHeight(detailRef.current.offsetHeight + 100)
  }, [])

  return (
    <div
      className="mx-auto my-10 bg-white shadow-1 w-72 lg:absolute lg:top-0 lg:right-36 lg:my-4"
      ref={detailRef}
    >
      <div className="relative w-full h-24 mb-8">
        <ImgFilters img={image} transparency />
      </div>

      <div className="p-4">
        <Button
          as="a"
          fullWidth
          className="uppercase"
          href={investment.hotMktLink}
        >
          {investment.calltoAction}
        </Button>
      </div>

      <div className="border-t border-b border-gray-100">
        <div className="p-4">
          <div className="flex mb-5">
            <div className="flex justify-center w-20">
              <img src={iconParaQuem} alt="" />
            </div>
            <div className="self-center flex-1">
              <Typography size="lg" weight="black" uppercase>
                Para quem?
              </Typography>
            </div>
          </div>
          <Typography weight="black" uppercase>
            {forWho}
          </Typography>
        </div>
      </div>

      <div className="border-b border-gray-100">
        <div className="p-4">
          <div className="flex mb-5">
            <div className="flex justify-center w-20">
              <img src={iconAgenda} alt="" />
            </div>
            <div className="self-center flex-1">
              <Typography size="lg" weight="black" uppercase>
                Carga horária
              </Typography>
            </div>
          </div>
          <Typography uppercase weight="black">
            {cargaHoraria}
          </Typography>
        </div>
      </div>

      <div>
        <div className="p-4">
          <div className="flex mb-5">
            <div className="flex justify-center w-20">
              <img src={iconBeneficios} alt="" />
            </div>
            <div className="self-center flex-1">
              <Typography size="lg" weight="black" uppercase>
                Benefícios
              </Typography>
            </div>
          </div>
          <ul className="px-4 list-disc list-outside">
            {beneficios.map(({beneficiosItem}) => (
              <li className="mb-1 text-blue-500" key={beneficiosItem}>
                <Typography color="gray-900" weight="black">
                  {beneficiosItem}
                </Typography>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {professor.map(prof => (
        <div className="border-b border-gray-100">
          <div className="relative flex justify-center h-24">
            <div className="absolute w-full h-px border-b border-gray-100 top-2/4 " />
            <div
              className="z-0 w-24 h-24 bg-center bg-top bg-no-repeat bg-cover rounded-full"
              style={{
                backgroundImage: `url(${prof.photo})`,
              }}
            ></div>
          </div>
          <div className="p-4 space-y-4">
            <Typography size="lg" weight="black" uppercase>
              {prof.nameShort}
            </Typography>
            <Typography className="text-justify">{prof.description}</Typography>
          </div>
        </div>
      ))}
      <div className="p-4">
        <Button
          as="a"
          fullWidth
          className="uppercase"
          href={investment.hotMktLink}
        >
          {investment.calltoAction}
        </Button>
      </div>
    </div>
  )
}

const CourseContent = ({content = []}) => {
  return (
    <div className="px-6 py-10 pb-10 space-y-4 lg:pr-100 lg:pl-32">
      {content.map(({contentTitle, contentTopics = []}) => (
        <div key={contentTitle}>
          <Typography size="lg" weight="black" uppercase>
            {contentTitle}
          </Typography>
          <ul className="mt-4 list-disc list-outside lg:pl-16">
            {contentTopics.map(({subTitle, description}) => (
              <Typography
                color="blue-500"
                as="li"
                key={subTitle}
                className="pb-4 space-y-4"
              >
                <Typography weight="black" uppercase>
                  {subTitle}
                </Typography>
                <Typography color="gray-900">{description}</Typography>
              </Typography>
            ))}
          </ul>
        </div>
      ))}
    </div>
  )
}

const Course = ({
  title,
  subtitle,
  introduction,
  videoLink,
  content = [],
  investment,
  professor,
  forWho,
  cargaHoraria,
  beneficios = [],
  image,
}) => {
  const allProfessors = useProfessorsQuery()
  const professorObj = [allProfessors.find(p => p.name === professor)].filter(
    Boolean,
  )

  content = content || []
  beneficios = beneficios || []

  const [height, setHeight] = React.useState(0)
  const titleProps = {title, subtitle}
  const introProps = {introduction, videoLink}
  const contentProps = {content}
  const detailProps = {
    investment,
    professor: professorObj,
    forWho,
    cargaHoraria,
    beneficios,
    image,
  }

  return (
    <div
      className="relative flex flex-col justify-top"
      style={{minHeight: ` ${height}px`}}
    >
      <TitleSection {...titleProps} />
      <IntroSection {...introProps} />
      <CourseDetails {...detailProps} setHeight={setHeight} />
      <CourseContent {...contentProps} />
      <ChamadaAzul
        text="QUER TER ACESSO A TODOS OS CURSOS?"
        linkText="CONHEÇA E ASSINE O PLANO ANUAL!"
        link={investment.hotMktLink}
        className=""
      />
      <Depositions />
    </div>
  )
}

export const RecorrenceCoursePageTemplate = props => (
  <div>
    <Hero />
    <Course {...props} />
  </div>
)

const Template = ({pageContext}) => {
  return <RecorrenceCoursePageTemplate {...pageContext?.frontmatter} />
}

export default Template
